import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	textField: {
		id: 'project-create-importer-upload-flow.common.utils.fields.text-field',
		defaultMessage: 'Text field',
		description: 'Drop down item text for to create a new Jira Custom Text Field',
	},
	paragraph: {
		id: 'project-create-importer-upload-flow.common.utils.fields.paragraph',
		defaultMessage: 'Paragraph',
		description: 'Drop down item text for to create a new Jira Custom Paragraph Field',
	},
	datePicker: {
		id: 'project-create-importer-upload-flow.common.utils.fields.date-picker',
		defaultMessage: 'Date',
		description: 'Drop down item text for to create a new Jira Custom Date Field',
	},
	number: {
		id: 'project-create-importer-upload-flow.common.utils.fields.number',
		defaultMessage: 'Number',
		description: 'Drop down item text for to create a new Jira Custom Number Field',
	},
	dateTime: {
		id: 'project-create-importer-upload-flow.common.utils.fields.date-time',
		defaultMessage: 'Time stamp',
		description: 'Drop down item text for to create a new Jira Custom Time Stamp Field',
	},
	label: {
		id: 'project-create-importer-upload-flow.common.utils.fields.label',
		defaultMessage: 'Labels',
		description: 'Drop down item text for to create a new Jira Custom Label Field',
	},
	select: {
		id: 'project-create-importer-upload-flow.common.utils.fields.select',
		defaultMessage: 'Dropdown',
		description: 'Drop down item text for to create a new Jira Custom Dropdown Field',
	},
	cascadingSelect: {
		id: 'project-create-importer-upload-flow.common.utils.fields.cascading-select',
		defaultMessage: 'Select List (Cascading)',
		description:
			'Cascading Select item text for to create a new Jira Custom Cascading Select Field',
	},
	checkbox: {
		id: 'project-create-importer-upload-flow.common.utils.fields.checkbox',
		defaultMessage: 'Checkbox',
		description: 'Drop down item text for to create a new Jira Custom Checkbox Field',
	},
	userPicker: {
		id: 'project-create-importer-upload-flow.common.utils.fields.user-picker',
		defaultMessage: 'User Picker',
		description: 'Drop down item text for to create a new Jira Custom User Picker Field',
	},
	multiUserPicker: {
		id: 'project-create-importer-upload-flow.common.utils.fields.multi-user-picker',
		defaultMessage: 'Multi User Picker',
		description: 'Drop down item text for to create a new Jira Custom Multi User Picker Field',
	},
	multiSelect: {
		id: 'project-create-importer-upload-flow.common.utils.fields.multi-select',
		defaultMessage: 'Multi Select',
		description: 'Drop down item text for to create a new Jira Custom Multi Select Field',
	},
	radio: {
		id: 'project-create-importer-upload-flow.common.utils.fields.radio',
		defaultMessage: 'Radio',
		description: 'Drop down item text for to create a new Jira Custom Radio Button Field',
	},
	url: {
		id: 'project-create-importer-upload-flow.common.utils.fields.url',
		defaultMessage: 'Url',
		description: 'Drop down item text for to create a new Jira Custom Url Field',
	},
	textFieldDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.text-field-description',
		defaultMessage: 'Supports single line of plain text',
		description: 'Drop down item description for a new Jira Custom Text Field',
	},
	paragraphDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.paragraph-description',
		defaultMessage: 'Supports long form rich text',
		description: 'Drop down item description for a new Jira Custom Paragraph Field',
	},
	dateTimeDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.date-time-description',
		defaultMessage: 'Stores date and time',
		description: 'Drop down item description for a new Jira Custom Time Stamp Field',
	},
	multiUserPickerDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.multi-user-picker-description',
		defaultMessage: 'To select multiple users',
		description: 'Drop down item description for a new Jira Custom Multi User Picker Field',
	},
	numberDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.number-description',
		defaultMessage: 'Stores numerical values',
		description: 'Drop down item description for a new Jira Custom Number Field',
	},
	selectDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.select-description',
		defaultMessage: 'To select single options in a list',
		description: 'Drop down item description for a new Jira Custom Dropdown Field',
	},
	multiSelectDescription: {
		id: 'project-create-importer-upload-flow.common.utils.fields.multi-select-description',
		defaultMessage: 'To select multiple options in a list',
		description: 'Drop down item description for a new Jira Custom Multi Select Field',
	},
});
